import { Outlet, Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";

const CPanelPrivateRoutes = () => {
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();
  const currentUrl = location.pathname;
  const lastPart = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
  const [lock, setLock] = useState("");

  const fetchdata = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    if (lastPart === "dashboard") {
      bodyFormData.append("pageName", "cpanel");
    } else {
      bodyFormData.append("pageName", lastPart);
    }
    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "admincontrol",
        },
      });
      if (response.status === 200) {
        const data = await response;
        if (data?.data === "Valid") {
          setIsValid(true);
        } else {
          setIsValid(false);
        }
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      throw new Error("Cpanel private route Error: ", error.message);
    } finally {
      setLock(lastPart);
    }
  };

  useEffect(() => {
    fetchdata();
  }, [location]);

  if (lock !== lastPart) {
    return;
  }

  let redirectRoute = "/";
  if (lastPart !== "dashboard") redirectRoute = "/cpanel/dashboard";
  if (lastPart === "dashboard") redirectRoute = "/";
  return isValid ? <Outlet /> : <Navigate to={redirectRoute} />;
};

export default CPanelPrivateRoutes;
